import store from "../store";
import actionTypes from "../actions/actionTypes";
import logger from "../../utils/logger";


export default (state = store, { type, payload }) => {
  switch (type) {
    case actionTypes.SAVE_FILTERS:
      return {
        ...state,
        filterOptions: payload,
      };

    case actionTypes.SAVE_SELECTED_FILTERS:
      return {
        ...state,
        selectedFilters: payload,
      };

    case actionTypes.SAVE_CART_DETAILS:
      return {
        ...state,
        cartDetails: payload,
      };

    case actionTypes.ADD_ENTRY:
      return {
        ...state,
        entries: [...state.entries, payload],
      };

    case actionTypes.REMOVE_ENTRY:
      return {
        ...state,
        entries: [...state.entries].filter(entry => entry.entryId !== payload),
      };

    case actionTypes.SET_ENTRIES:
      return {
        ...state,
        entries: payload,
      };
    // case actionTypes.ADD_ENTRY:
    // return {
    //     ...state,
    //     entries: []
    // }

    case actionTypes.ADD_TO_TOTAL_AMOUNT:
      return {
        ...state,
        totalCartAmount: (state.totalCartAmount += payload),
      };

    case actionTypes.SET_TOTAL_AMOUNT:
      return {
        ...state,
        totalCartAmount: payload,
      };

    case actionTypes.RESET_TOTAL_AMOUNT:
      return {
        ...state,
        totalCartAmount: 0,
      };

    case actionTypes.SAVE_CURRENT_ENTRY:
      return {
        ...state,
        currentEntry: payload,
      };

    case actionTypes.HAS_ITEMS:
      return {
        ...state,
        hasItems: payload,
      };

    case actionTypes.UPDATE_BUNDLE_QUANTITY:
      const bundleTypeAndQuantities = state.bundleTypeAndQuantities;

      let updatedState = [];

      if (bundleTypeAndQuantities && Array.isArray(bundleTypeAndQuantities)) {
        if (bundleTypeAndQuantities.length > 0) {
          if (bundleTypeAndQuantities.find(e => e.bundleType === payload.bundleType) === undefined) {
            const bundleTypeAndQuantity = {
              bundleType: payload.bundleType,
              quantity: payload.quantity,
            };

            updatedState = [...bundleTypeAndQuantities, bundleTypeAndQuantity];
          } else {
            const bundleTypeAndQuant = bundleTypeAndQuantities.filter(e => e.bundleType === payload.bundleType)[0];
            const updated = {
              ...bundleTypeAndQuant,
              quantity: payload.quantity,
            };

            const excludeBundleType = bundleTypeAndQuantities.filter(e => e.bundleType !== payload.bundleType);

            updatedState = [...excludeBundleType, updated];
          }
        } else {
          const bundleTypeAndQuantity = {
            bundleType: payload.bundleType,
            quantity: payload.quantity,
          };

          updatedState = [...bundleTypeAndQuantities, bundleTypeAndQuantity];
        }
      }

      return {
        ...state,
        bundleTypeAndQuantities: updatedState,
      };

    case actionTypes.RESET_BUNDLE_QUANTITY:
      return {
        ...state,
        bundleTypeAndQuantities: payload,
      };

    // Countries cases
    case actionTypes.SET_COUNTRIES:
      logger.log("🟢 [Reducer] SET_COUNTRIES:", {
        oldCountriesCount: state.countries?.length || 0,
        newCountriesCount: payload?.length || 0,
        payload: payload,
      });
      return {
        ...state,
        countries: payload,
        countriesLoading: false,
        countriesError: null,
      };

    case actionTypes.SET_COUNTRIES_LOADING:
      logger.log("🟡 [Reducer] SET_COUNTRIES_LOADING:", payload);
      return {
        ...state,
        countriesLoading: payload,
      };

    case actionTypes.SET_COUNTRIES_ERROR:
      logger.log("🔴 [Reducer] SET_COUNTRIES_ERROR:", payload);
      return {
        ...state,
        countriesError: payload,
        countriesLoading: false,
      };

    case actionTypes.CLEAR_COUNTRIES:
      logger.log("🗑️ [Reducer] CLEAR_COUNTRIES");
      return {
        ...state,
        countries: [],
        countriesLoading: false,
        countriesError: null,
      };

    // Currencies
    case actionTypes.SET_CURRENCIES:
      return {
        ...state,
        currencies: payload,
        currenciesLoading: false,
        currenciesError: null,
      };

    case actionTypes.SET_CURRENCIES_LOADING:
      return {
        ...state,
        currenciesLoading: payload,
      };

    case actionTypes.SET_CURRENCIES_ERROR:
      return {
        ...state,
        currenciesError: payload,
        currenciesLoading: false,
      };

    case actionTypes.CLEAR_CURRENCIES:
      return {
        ...state,
        currencies: [],
        currenciesLoading: false,
        currenciesError: null,
      };

    // Service Categories
    case actionTypes.SET_SERVICE_CATEGORIES:
      return {
        ...state,
        serviceCategories: payload,
        serviceCategoriesLoading: false,
        serviceCategoriesError: null,
      };

    case actionTypes.SET_SERVICE_CATEGORIES_LOADING:
      return {
        ...state,
        serviceCategoriesLoading: payload,
      };

    case actionTypes.SET_SERVICE_CATEGORIES_ERROR:
      return {
        ...state,
        serviceCategoriesError: payload,
        serviceCategoriesLoading: false,
      };

    case actionTypes.CLEAR_SERVICE_CATEGORIES:
      return {
        ...state,
        serviceCategories: [],
        serviceCategoriesLoading: false,
        serviceCategoriesError: null,
      };

    // Service Subcategories
    case actionTypes.SET_SERVICE_SUBCATEGORIES:
      return {
        ...state,
        serviceSubcategories: payload,
        serviceSubcategoriesLoading: false,
        serviceSubcategoriesError: null,
      };

    case actionTypes.SET_SERVICE_SUBCATEGORIES_LOADING:
      return {
        ...state,
        serviceSubcategoriesLoading: payload,
      };

    case actionTypes.SET_SERVICE_SUBCATEGORIES_ERROR:
      return {
        ...state,
        serviceSubcategoriesError: payload,
        serviceSubcategoriesLoading: false,
      };

    case actionTypes.CLEAR_SERVICE_SUBCATEGORIES:
      return {
        ...state,
        serviceSubcategories: [],
        serviceSubcategoriesLoading: false,
        serviceSubcategoriesError: null,
      };

    // Amenities
    case actionTypes.SET_AMENITIES:
      return {
        ...state,
        amenities: payload,
        amenitiesLoading: false,
        amenitiesError: null,
      };

    case actionTypes.SET_AMENITIES_LOADING:
      return {
        ...state,
        amenitiesLoading: payload,
      };

    case actionTypes.SET_AMENITIES_ERROR:
      return {
        ...state,
        amenitiesError: payload,
        amenitiesLoading: false,
      };

    case actionTypes.CLEAR_AMENITIES:
      return {
        ...state,
        amenities: [],
        amenitiesLoading: false,
        amenitiesError: null,
      };

    // Payment Institutions
    case actionTypes.SET_PAYMENT_INSTITUTIONS:
      return {
        ...state,
        paymentInstitutions: payload,
        paymentInstitutionsLoading: false,
        paymentInstitutionsError: null,
      };

    case actionTypes.SET_PAYMENT_INSTITUTIONS_LOADING:
      return {
        ...state,
        paymentInstitutionsLoading: payload,
      };

    case actionTypes.SET_PAYMENT_INSTITUTIONS_ERROR:
      return {
        ...state,
        paymentInstitutionsError: payload,
        paymentInstitutionsLoading: false,
      };

    case actionTypes.CLEAR_PAYMENT_INSTITUTIONS:
      return {
        ...state,
        paymentInstitutions: [],
        paymentInstitutionsLoading: false,
        paymentInstitutionsError: null,
      };

    case actionTypes.LOGOUT_USER:
      return {
        ...store, // Reset to initial state
        entries: [],
        cartDetails: [],
        hasItems: false,
        totalCartAmount: 0,
        currentEntry: null,
        selectedFilters: {},
        filterOptions: {},
        orderSummary: null,
        countries: [],
        countriesLoading: false,
        countriesError: null,
        currencies: [],
        currenciesLoading: false,
        currenciesError: null,
        serviceCategories: [],
        serviceCategoriesLoading: false,
        serviceCategoriesError: null,
        serviceSubcategories: [],
        serviceSubcategoriesLoading: false,
        serviceSubcategoriesError: null,
        amenities: [],
        amenitiesLoading: false,
        amenitiesError: null,
        paymentInstitutions: [],
        paymentInstitutionsLoading: false,
        paymentInstitutionsError: null,
      };

    default:
      return state;
  }
};
